(function () {
  if (window.plaudTeamsMarqueeInstalled) return;
  window.plaudTeamsMarqueeInstalled = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(container) {
    container.querySelectorAll('[data-plaud-marquee]').forEach(function (marquee) {
      if (marquee.plaudMarqueeCleanup) return;

      var track = marquee.querySelector('.plaud-teams__marquee-track');
      var first = track && track.firstElementChild;
      var repeat = track && track.querySelector('[data-marquee-repeat]');
      if (!first || !repeat) return;

      var period = 0;
      var offset = 0;
      var frame = 0;
      var lastTime = null;
      var visible = false;
      var speed = Number(marquee.dataset.speed) || 20;

      function measure() {
        period = repeat.offsetLeft - first.offsetLeft;
        if (period > 0) offset %= period;
      }

      function tick(time) {
        if (!marquee.isConnected) { cleanup(); return; }
        if (lastTime !== null && period > 0) {
          offset = (offset + (time - lastTime) * speed / 1000) % period;
          track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
        }
        lastTime = time;
        frame = requestAnimationFrame(tick);
      }

      function sync() {
        if (visible && !reducedMotion.matches && document.visibilityState !== 'hidden' && period > 0) {
          if (!frame) frame = requestAnimationFrame(tick);
        } else {
          cancelAnimationFrame(frame);
          frame = 0;
          lastTime = null;
          if (reducedMotion.matches) {
            offset = 0;
            track.style.transform = '';
          }
        }
      }

      var resizeObserver = new ResizeObserver(function () { measure(); sync(); });
      resizeObserver.observe(track);
      resizeObserver.observe(marquee);

      var intersectionObserver = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        sync();
      });
      intersectionObserver.observe(marquee);

      function cleanup() {
        cancelAnimationFrame(frame);
        resizeObserver.disconnect();
        intersectionObserver.disconnect();
        document.removeEventListener('visibilitychange', sync);
        reducedMotion.removeEventListener('change', sync);
        marquee.plaudMarqueeCleanup = null;
      }

      marquee.plaudMarqueeCleanup = cleanup;
      document.addEventListener('visibilitychange', sync);
      reducedMotion.addEventListener('change', sync);
      measure();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-plaud-marquee]').forEach(function (marquee) {
      if (marquee.plaudMarqueeCleanup) marquee.plaudMarqueeCleanup();
    });
  });
})();
